import WinnerDisplay from "../winnerDisplay";
import ShareButton from "../shareButton/shareButton";
import "./champion.sass";

export default function Champion({ winner, qualifyingState }) {
  return (
    <div className="ChampionSection">
      <WinnerDisplay winner={winner} variant="champion" />
      <div className="ChampionTitle">CAMPEÓN</div>
      <ShareButton winner={winner} qualifyingState={qualifyingState} />
    </div>
  );
}